export default __webpack_public_path__ + "static/media/postgresql.c0d71b7c.svg";